import { html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class BasicHTML extends OutlineElement {
  static get properties() {
    return {
      headline: { type: String },
    };
  }

  render() {
    return html`
      <div>
        <hf-heading level="2" levelStyle="heading2">
          ${this.headline}
        </hf-heading>
        <slot></slot>
      </div>
    `;
  }
}

customElements.define('hf-basic-html', BasicHTML);
